
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, map, toArray} from 'rxjs/operators';
import {v4 as uuid} from 'uuid';

@HookClass('uuid')
export class UUIDHook extends BaseHook {

    @Hook('b50e5769-172e-4611-b348-9f36d4e98a04')
    public set(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const fields = inputArtifact.object.map;
        return from(fields)
            .pipe(map((field: string) => inputArtifact.object.data[field] = uuid()), toArray())
            .pipe(concatMap(() => of(inputArtifact)));
    }

    @Hook('31e2bd19-5887-4335-ac2c-712520d90149')
    public uuid(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ARRAY;
        outputArtifact.object = uuid();
        return of(outputArtifact);
    }

    @Hook('d6b3a675-a4f1-448b-948b-dc8aa973ba06')
    public short(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const fields = inputArtifact.object.fields;
        return from(fields)
            .pipe(map((field: string) => inputArtifact.object.data[field] = uuid().split('-')[0].toUpperCase()), toArray())
            .pipe(concatMap(() => of(inputArtifact)));
    }

}
